import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const MesDonnees = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-100 min-h-screen flex justify-center items-center relative">
      <button 
        onClick={() => navigate(-1)} 
        className="absolute top-4 left-4 flex items-center text-blue-600 hover:text-blue-800"
      >
        <ArrowLeft size={24} className="mr-2" />
        Retour
      </button>
      <div className="max-w-4xl w-full p-6 bg-white shadow-lg rounded-lg">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Mes Données</h1>
        <p className="text-gray-600 mb-6">Gérez et mettez à jour vos informations personnelles.</p>

        <div className="space-y-4">
          <div>
            <label className="block text-gray-700 font-semibold">Nom</label>
            <input type="text" className="w-full p-2 border rounded" placeholder="Votre nom" />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold">Prénom</label>
            <input type="text" className="w-full p-2 border rounded" placeholder="Votre prénom" />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold">Adresse Email</label>
            <input type="email" className="w-full p-2 border rounded" placeholder="Votre email" />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold">Téléphone</label>
            <input type="tel" className="w-full p-2 border rounded" placeholder="Votre numéro de téléphone" />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold">Adresse</label>
            <input type="text" className="w-full p-2 border rounded" placeholder="Votre adresse" />
          </div>

          <button className="w-full bg-blue-600 text-white py-2 rounded mt-4 hover:bg-blue-700">
            Enregistrer les modifications
          </button>
        </div>
      </div>
    </div>
  );
};

export default MesDonnees;